import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const CustomerSchema = z.object({
  id: IdSchema,
  name: z.string().min(1).max(200),
  email: z.string().email().nullable(),
  phone: z.string().max(50).nullable(),
  company: z.string().max(200).nullable(),
  bookingReference: z.string().max(100).nullable(),
  notes: z.string().default(''),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Customer = z.infer<typeof CustomerSchema>;

export const CreateCustomerSchema = CustomerSchema.pick({
  name: true,
  email: true,
  phone: true,
  company: true,
  bookingReference: true,
  notes: true,
}).partial({
  email: true,
  phone: true,
  company: true,
  bookingReference: true,
  notes: true,
});
export type CreateCustomerInput = z.infer<typeof CreateCustomerSchema>;

export const UpdateCustomerSchema = CreateCustomerSchema.partial();
export type UpdateCustomerInput = z.infer<typeof UpdateCustomerSchema>;

export const CustomerSearchQuerySchema = z.object({
  q: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type CustomerSearchQuery = z.infer<typeof CustomerSearchQuerySchema>;
